import Pages from './Pages/Main';
import PagesView from './Pages/View';
import Blog from './Blog/Main';
import BlogView from './Blog/View';
import Themes from './Themes/Main';
import EditTwig from './Themes/EditTwig';
import Languages from './Languages/Main';
import EditLanguage from './Languages/Edit';
import Menu from './Menu/Main';
import Files from './Files/Main';

export const routesAppearance = [
  {
    name: 'Pages',
    link: '/appearance/pages',
    component: Pages,
    code: 'pages',
    menu: 'pages',
    exact: true,
    react: true,
  },
  {
    name: 'Page',
    link: '/appearance/create-page',
    component: PagesView,
    code: 'create-page',
    menu: 'pages',
    exact: true,
    react: true,
  },
  {
    name: 'Page',
    link: '/appearance/edit-page',
    component: PagesView,
    menu: 'pages',
    code: 'edit-page',
    exact: true,
    react: true,
  },
  {
    name: 'Blog',
    link: '/appearance/blog',
    component: Blog,
    code: 'blog',
    menu: 'blog',
    exact: true,
    react: true,
  },
  {
    name: 'Blog view',
    link: '/appearance/create-blog',
    component: BlogView,
    code: 'create-blog',
    menu: 'blog',
    exact: true,
    react: true,
  },
  {
    name: 'Blog view',
    link: '/appearance/edit-blog',
    component: BlogView,
    menu: 'blog',
    code: 'edit-blog',
    exact: true,
    react: true,
  },
  {
    name: 'Themes',
    link: '/appearance/themes',
    component: Themes,
    menu: 'themes',
    code: 'themes',
    exact: true,
    react: true,
  },
  {
    name: 'Themes preview',
    link: '/appearance/theme-preview',
    component: EditTwig,
    menu: 'themes',
    code: 'themes-preview',
    exact: true,
    react: true,
  },
  {
    name: 'Themes edit',
    link: '/appearance/file-edit',
    component: EditTwig,
    menu: 'themes',
    code: 'file-edit',
    exact: true,
    react: true,
  },
  {
    name: 'Languages',
    link: '/appearance/languages',
    component: Languages,
    menu: 'languages',
    code: 'languages',
    exact: true,
    react: true,
  },
  {
    name: 'Edit language',
    link: '/appearance/language-edit',
    component: EditLanguage,
    menu: 'languages',
    code: 'edit-language',
    exact: true,
    react: true,
  },
  {
    name: 'Menu',
    link: '/appearance/menu',
    component: Menu,
    code: 'menu',
    menu: 'menu',
    exact: true,
    react: true,
  },
  {
    name: 'Files',
    link: '/appearance/files',
    component: Files,
    menu: 'files',
    code: 'files',
    exact: true,
    react: true,
  },
];
export const getRoutesAppearance = () => routesAppearance
